// Reasons for files to be rejected

export enum RejectionReasons {
  None,
  FileType,
  FileSize,
  Unknown,
  FilesNumber
}
